import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PlatformSectionService } from '../../platform-section/platform-section.service';
import { EditPlatformSection } from '../../platform-section/platform-section.interface';
import { PlatformFaqService } from '../platform-faq.service';
import { IFAQAddPayload, IFAQForm } from '../platform-faq.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-faq',
  templateUrl: './add-faq.component.html',
  styleUrls: ['./add-faq.component.scss'],
})
export class AddFaqComponent implements OnInit {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  isSectionsLoading = true;
  sections$!: Observable<EditPlatformSection[]>;

  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    section_id: new FormControl('', [Validators.required]),
    observations: new FormControl('', [Validators.required]),
  });

  constructor(
    private dialogRef: MatDialogRef<AddFaqComponent>,
    private platformFaqService: PlatformFaqService,
    private platformSectionService: PlatformSectionService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.getSectionsList();
  }

  getSectionsList() {
    let platformResponse = this.platformSectionService
      .getPlatformSections()

    platformResponse.subscribe({
      next: (sections: any) => {
        this.sections$ = of(sections.data as EditPlatformSection[]);
        this.isSectionsLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isSectionsLoading = false;
      },
    });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.platformFaqService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, section_id, observations } = this.form.value as IFAQForm;
    const newFAQ: IFAQAddPayload = {
      name,
      section_id,
      observations
    };

    this.platformFaqService
      .addFAQ(newFAQ)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
